import * as React from "react";
import { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import { Nullable } from "../../@typings/typings";
import { useStyles } from "./BigLoader.styles";

export function BigLoader() {
  const [alertText, setAlertText] = useState<Nullable<string | React.ReactElement>>(null);
  const classes = useStyles();

  useEffect(() => {
    const timer = setTimeout(
      () => setAlertText(<>Если загрузка идет слишком долго &mdash; попробуйте перезагрузить страницу.</>),
      3000
    );
    return () => clearTimeout(timer);
  }, []);

  return (
    <Paper
      style={{
        height: "500px",
      }}
    >
      <Grid container justify={"center"} alignItems={"center"} className={classes.container}>
        <Grid item className={classes.item}>
          <Grid container direction={"column"} justify={"center"} alignItems={"center"} spacing={4}>
            <Grid item>
              <CircularProgress size={64} />
            </Grid>
            <Grid item>
              <Box fontSize={16}>Загрузка...</Box>
            </Grid>
            <Grid
              item
              style={{
                visibility: alertText ? "visible" : "hidden",
              }}
            >
              <Alert severity={"info"}>{alertText}</Alert>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
